<template>
    <article>
        <SectionLabel :label="trads.label"></SectionLabel>
        <Loader v-if="loading" :loading="true"></Loader>
        <section>
            <label>{{ trads.estoreAvailability.label }}</label>
            <RadioGroup id="estore" v-model="value.eStoreType" name="estore" :options="estoreAvailability"></RadioGroup>
        </section>

        <div class="default-price-container" v-if="displayDefaultPriceContainer">
            <label>{{ trads.defaultPrice }}</label>
            <NumberInput v-model="defaultPrice"></NumberInput>
            <ClientColorButton :size="'s'" @click="applyDefaultPrice">{{ trads.applyPrices }}</ClientColorButton>
        </div>

        <section id="price-container" v-if="displayPriceContainer">
            <!--
                since we can't generate two items with v-for without wrapping them in a div
                instead we have two v-for, and reorder the items using CSS
            -->
            <label
                v-for="(zonePrice, index) in listDisplayed"
                :key="zonePrice.zone.id"
                :for="`zone-${zonePrice.zone.id}`"
                :style="{ order: index * COLUMN_NUMBER_IN_TEMPLATE }"
            >
                {{ zonePrice.zone.name }} <span v-if="isDisabledZone(zonePrice.zone.id)"><i>(DELETED)</i></span>
            </label>
            <div :style="{ order: index * COLUMN_NUMBER_IN_TEMPLATE + 1 }" v-for="(zonePrice, index) in listDisplayed" :key="zonePrice.zone.id">
                <span>{{ zonePrice.currency.symbol }}</span>
                <NumberInput
                    v-if="!isDisabledZone(zonePrice.zone.id)"
                    :value="zonePrice.value"
                    @input="newValue => change(index, newValue)"
                    :id="`zone-${zonePrice.zone.id}`"
                    :style-object="{ width: '50px' }"
                >
                </NumberInput>
                <span v-else> {{ zonePrice.value }} </span>
            </div>
        </section>
    </article>
</template>

<script>
import RadioGroup from "./components/radio-group";
import SectionLabel from "./components/section-label";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import Loader from "@/components/loader/loader";
import NumberInput from "@/plano/components/number-input";
import { ESTORE_AVAILABILITY } from "@/services/component";
import { mapState } from "vuex";
import ClientColorButton from "@/components/ui/ClientColorButton";

const COLUMN_NUMBER_IN_TEMPLATE = 3;

export default {
    mixins: [TryLoadMixin],
    components: { RadioGroup, SectionLabel, Loader, NumberInput, ClientColorButton },
    props: {
        value: { type: Object, required: true },
        zones: { type: Array },
        brandZones: { type: Array },
        zonesChecked: { type: Object }
    },
    data: () => ({
        COLUMN_NUMBER_IN_TEMPLATE,
        listPricePerZone: [],
        applyPricesStatus: false,
        defaultPrice: 0
    }),
    watch: {
        zonesChecked() {
            this.updateListPricePerZone();
        },
        displayPriceContainer(oldValue, newValue) {
            if (oldValue !== newValue) this.updateListPricePerZone();
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
        trads() {
            return this.$trad.admin.componentForm.estore;
        },
        estoreAvailability() {
            const res = [];
            for (const key of Object.keys(ESTORE_AVAILABILITY)) {
                res.push({
                    value: key === ESTORE_AVAILABILITY.unavailable ? undefined : ESTORE_AVAILABILITY[key],
                    label: this.trads.estoreAvailability[key]
                });
            }
            return res;
        },
        displayPriceContainer() {
            return this.value.eStoreType === ESTORE_AVAILABILITY.everybody || this.value.eStoreType === ESTORE_AVAILABILITY.diamOnly;
        },
        listDisplayed() {
            return this.listPricePerZone.filter(priceObject => priceObject.checked);
        },
        displayDefaultPriceContainer() {
            return this.displayPriceContainer && this.listDisplayed.length > 0;
        }
    },
    methods: {
        updateListPricePerZone() {
            for (const index in this.listPricePerZone) {
                const priceObject = this.listPricePerZone[index];
                this.listPricePerZone[index].checked = Boolean(
                    this.zonesChecked[priceObject.zone.id] && this.zonesChecked[priceObject.zone.id].checked
                );
            }
        },
        change(index, value) {
            this.listDisplayed[index].value = value;
            this.$emit("input", { ...this.value, prices: this.listDisplayed });
        },
        applyDefaultPrice() {
            for (const index in this.listPricePerZone) {
                if (this.listPricePerZone[index].checked && !this.isDisabledZone(this.listPricePerZone[index].zone.id)) {
                    this.listPricePerZone[index].value = this.defaultPrice;
                }
            }
        },
        isDisabledZone(zoneId) {
            const brandZone = this.brandZones.find(bz => bz.zone.id === zoneId);
            if (!brandZone) {
                return true;
            }
            return !brandZone.active;
        }
    },
    created() {
        for (const zone of this.zones) {
            const priceInZone = this.value.prices && this.value.prices.find(price => price.zone.id === zone.id);
            const value = (priceInZone && priceInZone.value) || 0;
            const currency = (priceInZone && priceInZone.currency) || (this.currentBrand && this.currentBrand.currency) || { symbol: "€" };
            this.listPricePerZone.push({ value, zone, checked: false, currency });
        }
        this.updateListPricePerZone();
    }
};
</script>

<style lang="scss">
article {
    position: relative;
}

.default-price-container {
    margin: 20px 0;
    & > * {
        display: inline-block;
        margin-right: 10px;
    }
    & input {
        width: 50px;
    }
}

@media (min-width: 767px) {
    #estore {
        width: 100%;
    }
    #main #component-form section#price-container {
        grid-template-columns: 100px 200px 100px 200px;
    }
}
</style>



// WEBPACK FOOTER //
// form-estore.vue?5a889165